import React from "react";
import styled from "styled-components";
import Typography from "components/typography";
import { Colors } from "utils/colors";
import FAQElement from "components/FAQ";

const FAQs = () => {
  const FAQdata = [
    {
      q: "Are Promo Cards free to use?",
      a: "Are Promo Cards free to use?es! If you have an active Rated Afrika account, you can create and download promo cards for free."
    },
    {
      q: "Can I use my own images?",
      a: "Currently, promo cards are generated using your track’s official artwork, by using a background of yours choice."
    },
    {
      q: "What platforms can I share my promo cards on?",
      a: "Promo cards are optimized for all major social media platforms, including Instagram, Twitter, Facebook, and WhatsApp."
    },
    {
      q: "Do I need design skills to use Promo Cards?",
      a: "Nope! Our tool is super simple—just choose your release, make a choice from a variety of background choices, generate and download."
    }
  ];
  return (
    <Container>
      <Typography
        color={Colors.white300}
        size="3.6rem"
        weight="semibold"
        align="center"
        m_size="4xl"
      >
        Frequently asked questions
      </Typography>
      <Typography
        color={Colors.grey600}
        size="2xl"
        m_size="lg"
        mt="2"
        align="center"
      >
        Everything you need to know about Promo Cards
      </Typography>
      <Items>
        {FAQdata.map(({ q, a }, i) => {
          return (
            <Item key={i}>
              <FAQElement q={q} a={a} />
            </Item>
          );
        })}
      </Items>
    </Container>
  );
};

export default FAQs;

const Container = styled.div`
  margin-top: 8rem;
  padding-bottom: 10rem;
  position: relative;
`;

const Items = styled.div`
  margin-top: 6.8rem;
  width: 65%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
  @media only screen and (max-width: 769px) {
    width: 100%;
    margin-top: 3.2rem;
  }
`;
const Item = styled.div`
  margin-bottom: 3.2rem;
  width: 100%;
`;
